import * as Sentry from '@sentry/react';

export function logError(err) {
  if (import.meta.env.DEV) {
    console.error(err);
  } else {
    Sentry.captureException(err);
  }
}
